// eslint-disable-next-line import/prefer-default-export
export enum EntityType {
  Contact = "contact",
  Lead = "lead",
}
